module.exports = __webpack_public_path__ + "img/exercise-walker.01a4ff9c.png";